import { getDefaultAudioUrl, getDefaultVideoUrl } from './convertNodes.js';
import { toPlainTextBase } from './to-plain-text-base.js';
import 'ricos-schema';
import '../../../consts.js';
import '../../draft/toDraft/decorationParsers.js';
import 'lodash';
import '../../draft/consts.js';
import '../../../utils.js';
import '../../draft/emojiRegex.js';
import '../../draft/toDraft/getDraftEntityData.js';
import '../../draft/toDraft/convertDraftPluginData.js';
import '../../nodeUtils.js';
import '../../../ReadonlyNonEmptyArray-0e481d0b.js';
import '../../../string-40bcd6bf.js';
import 'uuid';
import '../../generateRandomId.js';
import '../../draft/toDraft/create-entity.js';

const toPlainText = async (content, options = {}) => {
  var _a;
  const gen = toPlainTextBase(content, options.delimiter, options.addLinksToText);
  let next = gen.next();
  while (!next.done) {
    switch (next.value.command) {
      case "getImageUrl": {
        const url = options.urlShortener ? await ((_a = options.urlShortener) == null ? void 0 : _a.call(options, next.value.data)) : next.value.data;
        next = gen.next(url);
        break;
      }
      case "getVideoUrl": {
        const url = await (options.getVideoUrl ? options.getVideoUrl(next.value.data) : getDefaultVideoUrl(next.value.data));
        next = gen.next(url);
        break;
      }
      case "getVideoEmbeddedUrl": {
        const url = await (options.getVideoEmbeddedUrl ? options.getVideoEmbeddedUrl(next.value.data) : next.value.data);
        next = gen.next(url);
        break;
      }
      case "getAudioUrl": {
        const url = await (options.getAudioUrl ? options.getAudioUrl(next.value.data) : getDefaultAudioUrl(next.value.data));
        next = gen.next(url);
        break;
      }
      case "getGifUrl": {
        const url = await (options.getGifUrl ? options.getGifUrl(next.value.data) : next.value.data);
        next = gen.next(url);
        break;
      }
      default:
        return "";
    }
  }
  return next.value;
};

export { toPlainText };
//# sourceMappingURL=toPlainText.js.map
